import { Button, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import { useFormContext } from "react-hook-form"
import AddIcon from '@mui/icons-material/Add';
import { useState } from "react";
import DialogAdicionar, { ValoresRateio } from "./DialogAdicionar";
import EditIcon from '@mui/icons-material/Edit';

export default function DisplayRateio() {

    const { watch } = useFormContext()
    const itensRateio: ValoresRateio[] = watch('step03.rateios') || []

    const [openDialogAdicionar, setOpenDialogAdicionar] = useState<boolean>(false)

    const paddingStyle = { paddingLeft: 0, paddingRight: 0 }

    return (
        <>
            {
                itensRateio.length === 0 &&
                <Stack
                    direction={"column"}
                    spacing={1}
                    justifyContent={"center"}
                    alignItems={"center"}
                    minHeight={150}
                    border={1}
                    borderColor={"primary.main"}
                    borderRadius={2}
                >
                    <Typography color={"primary.main"}>
                        Nenhum centro de custo selecionado
                    </Typography>

                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<AddIcon />}
                        onClick={() => setOpenDialogAdicionar(true)}
                    >
                        Adicionar rateio
                    </Button>
                </Stack>
            }

            {
                itensRateio.length > 0 &&
                <TableContainer sx={{ maxWidth: 500 }}>
                    <Table size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={paddingStyle}><b>Conta devedora</b></TableCell>
                                <TableCell align="right" sx={paddingStyle}><b>Valor</b></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {itensRateio.map((row, index) => (
                                <TableRow
                                    key={index}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row" sx={paddingStyle}>
                                        <Typography variant="body2">
                                            {`${row.contaDevedora?.codigo_contabil} - ${row.contaDevedora?.nome}`}
                                        </Typography>
                                        {
                                            row.contaDevedora?.centro_custo &&
                                            <Typography variant="caption" color={"text.secondary"}>
                                                {`${row.contaDevedora.centro_custo.id} - ${row.contaDevedora.centro_custo.nome}`}
                                            </Typography>
                                        }
                                    </TableCell>
                                    <TableCell align="right" sx={paddingStyle}>{row.valor}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                    <Stack direction="row" justifyContent="flex-end" mt={2}>
                        <Button
                            variant="outlined"
                            size="small"
                            startIcon={<EditIcon />}
                            onClick={() => setOpenDialogAdicionar(true)}
                        >
                            Editar
                        </Button>
                    </Stack>
                </TableContainer>
            }

            {
                openDialogAdicionar &&
                <DialogAdicionar
                    open={openDialogAdicionar}
                    handleClose={() => setOpenDialogAdicionar(false)}
                />
            }
        </>
    )
}